"use client";
import React from "react";
import "./StickyWidget.css";
import Button from "../Button";
import { getMarketCountryName } from "@/lib/envConfig";

function StickyWidget() {
  const marketCountry = getMarketCountryName();

  return (
    <div className="StickyWidget">
      <div className="Widget">
        <h3>Registiere dich auf Autoeinfachlos</h3>

        <p>
          Autoeinfachlos bietet dir direkten Zugang zu den besten Gebrauchtwagen
          in {marketCountry} zu den niedrigsten Preisen – und das in
          Sekundenschnelle.
        </p>

        <Button link="/registrieren">Jetzt Registrieren</Button>
      </div>
    </div>
  );
}

export default StickyWidget;
